var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 117,
    viewBox: "0 0 97 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5862 78.3034V55.6597H4.4707V82.4985C4.4707 91.9679 12.1488 99.6441 21.6206 99.6441H64.7208V85.5321H25.82C21.8246 85.5354 18.5862 82.2978 18.5862 78.3034Z",
    fill: "#BC3C95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1183 85.536H25.82C21.8246 85.536 18.5861 82.2984 18.5861 78.304V74.688C18.5861 74.688 16.0388 99.648 35.6307 99.648H91.5793L77.1183 85.536Z",
    fill: "url(#paint0_linear_9_143)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3099 6.89752C73.3796 10.6616 79.4616 16.1926 83.7729 23.6681C86.2577 27.975 87.9197 32.588 88.4956 37.5432C88.6865 39.185 89.2592 40.1655 90.9475 40.8993C94.7059 42.5279 96.47 46.2953 96.0355 50.9609C64.0757 50.9609 32.0994 50.9609 0.136337 50.9609C-0.541629 46.3151 1.32113 42.5477 5.45145 40.7479C6.98839 40.0767 7.33396 39.1061 7.56104 37.6452C9.74962 23.5957 17.4804 13.6031 30.0655 7.22655C30.2597 7.12784 30.4967 7.11139 31.0068 6.97978C31.6617 11.8724 32.3397 16.696 32.9288 21.5294C33.1131 23.0363 33.4784 24.4577 35.2161 24.4314C37.1776 24.3985 37.3224 22.8192 37.3158 21.2431C37.2928 16.0873 37.2862 10.9314 37.3158 5.77224C37.3356 2.08055 38.6323 0.409091 42.2887 0.182062C46.2544 -0.0679989 50.2663 -0.0647086 54.2321 0.218255C57.6153 0.458446 58.8593 2.16939 58.8659 5.60444C58.8758 10.8393 58.889 16.0708 58.8593 21.3056C58.8495 22.8225 59.1095 24.2504 60.8406 24.4347C62.6474 24.6288 63.1048 23.1647 63.299 21.7136C63.8453 17.5975 64.3522 13.4781 64.8886 9.35865C64.9841 8.60846 65.1387 7.87473 65.3099 6.89752Z",
    fill: "url(#paint1_linear_9_143)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5761 99.647H59.9257V116.299L91.5761 99.647Z",
    fill: "#902372"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8151 78.0134H30.217C29.4435 78.0134 28.8182 77.3883 28.8182 76.615V62.8979C28.8182 62.1247 29.4435 61.4995 30.217 61.4995H35.8151C36.5885 61.4995 37.2138 62.1247 37.2138 62.8979V76.615C37.2138 77.385 36.5852 78.0134 35.8151 78.0134Z",
    fill: "#902372"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8858 78.0134H60.2876C59.5142 78.0134 58.8889 77.3883 58.8889 76.615V62.8979C58.8889 62.1247 59.5142 61.4995 60.2876 61.4995H65.8858C66.6592 61.4995 67.2845 62.1247 67.2845 62.8979V76.615C67.2845 77.385 66.6592 78.0134 65.8858 78.0134Z",
    fill: "#902372"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1183 55.6631V85.4664L91.5761 99.6311V55.6631H77.1183Z",
    fill: "#BC3C95"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_143",
    x1: 91.5763,
    y1: 87.1678,
    x2: 18.4765,
    y2: 87.1678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC3D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B236F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_143",
    x1: 0.00110567,
    y1: 25.4758,
    x2: 96.1011,
    y2: 25.4758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC3D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B236F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotLogo);
export default __webpack_public_path__ + "static/media/chatbot-logo.e1fec8419ca202445f7d0cc9a523bb87.svg";
export { ForwardRef as ReactComponent };